//------------------------------------for-live------------------------------------*/
export const Baseurl ="https://honey-streaming.com";

//------------------------------------for-development------------------------------------*/
// export const Baseurl ="http://localhost:9001";



export const MediaBaseUrl = "https://honey-streaming.com"